enum Routes {
  ADDRESS = "ADDRESS",
  API = "API",
  ASSETS = "ASSETS",
  BLOCK = "BLOCK",
  BLOCKS = "BLOCKS",
  HOME = "HOME",
  TRANSACTION = "TRANSACTION",
  ASSET = "ASSET",
}

export default Routes;
